/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export enum CustomAttributeServerType {
  TEXT = 'Text',
  RICH_TEXT = 'Rich Text',
  DROPDOWN = 'Dropdown',
  CHECKBOX = 'Checkbox',
  DATE = 'Date',
  MAP = 'Map',
  INT = 'Integer',
  FLOAT = 'Decimal',
  MULTI = 'Multi choice',
}

export interface CustomAttributeDefinition {
  id: number;
  attributeType: CustomAttributeServerType;
  definitionType: string;
  title: string;
  helptext?: string;
  placeholder?: string;
  multiChoiceOptions?: string;
  mandatory: boolean;
}
